import { createFileRoute } from "@tanstack/react-router";

import { requireInternalAudience, landingPathFor } from "@/lib/route-guards";
import { redirectOffTree } from "@/lib/route-paths";

// `/` is the single source of the landing path: it never renders, it only
// dispatches. Post-login forwarding already arrives here (completeLogin
// defaults returnTo to `/`), and the legacy `/dashboard` bookmark resolves to
// here's destination too, so retargeting one constant moves every landing.
//
// The _authed layout guarantees an authenticated user; requireInternalAudience
// fails closed (redirecting to the external landing) for external or absent
// users before the internal landing is ever reached.
export const Route = createFileRoute("/_authed/_chrome/")({
  beforeLoad: ({ context }) => {
    requireInternalAudience(context.currentUser.user);
    redirectOffTree(landingPathFor("internal"));
  },
});
